{
  "REPORT": {
    "HEADER": "對話",
    "LOADING_CHART": "正在載入圖表資料...",
    "NO_ENOUGH_DATA": "我們尚未收到足夠的資料來產生報表，請稍後再試。",
    "DOWNLOAD_CONVERSATION_REPORTS": "下載對話報表",
    "DATA_FETCHING_FAILED": "無法取得資料，請稍後再試。",
    "SUMMARY_FETCHING_FAILED": "無法取得摘要，請稍後再試。",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "對話",
        "DESC": "（總計）"
      },
      "INCOMING_MESSAGES": {
        "NAME": "收到的訊息",
        "DESC": "（總計）"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "發送的訊息",
        "DESC": "（總計）"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "首次回應時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "首次回應時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_TIME": {
        "NAME": "解決時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "解決時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "轉接數量",
        "DESC": "（總計）"
      },
      "REPLY_TIME": {
        "NAME": "客戶等待時間",
        "TOOLTIP_TEXT": "等待時間為 {metricValue}（基於 {conversationCount} 則回覆）",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "最近 7 天",
      "LAST_14_DAYS": "最近 14 天",
      "LAST_30_DAYS": "最近 30 天",
      "THIS_MONTH": "本月",
      "LAST_MONTH": "上個月",
      "LAST_3_MONTHS": "最近 3 個月",
      "LAST_6_MONTHS": "最近 6 個月",
      "LAST_YEAR": "去年",
      "CUSTOM_DATE_RANGE": "自訂日期範圍"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "套用",
      "PLACEHOLDER": "選擇日期範圍"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "分組依據",
    "DURATION_FILTER_LABEL": "期間",
    "GROUPING_OPTIONS": {
      "DAY": "日",
      "WEEK": "週",
      "MONTH": "月",
      "YEAR": "年"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "日"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "日"
      },
      {
        "id": 2,
        "groupBy": "週"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "日"
      },
      {
        "id": 2,
        "groupBy": "週"
      },
      {
        "id": 3,
        "groupBy": "月"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "週"
      },
      {
        "id": 3,
        "groupBy": "月"
      },
      {
        "id": 4,
        "groupBy": "年"
      }
    ],
    "BUSINESS_HOURS": "服務時間",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "清除篩選條件",
      "EMPTY_LIST": "查無結果"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "載入更多",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "未指派",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "顯示第 {start} 至 {end} 筆，共 {total} 筆結果",
      "PER_PAGE_TEMPLATE": "{size} / 頁"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "客服總覽",
    "DESCRIPTION": "輕鬆追蹤客服績效，包含對話數、回應時間、解決時間及已解決案件等關鍵指標。點擊客服名稱以瞭解更多。",
    "LOADING_CHART": "正在載入圖表資料...",
    "NO_ENOUGH_DATA": "我們尚未收到足夠的資料來產生報表，請稍後再試。",
    "DOWNLOAD_AGENT_REPORTS": "下載客服報表",
    "FILTER_DROPDOWN_LABEL": "選擇客服",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "搜尋客服"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "對話",
        "DESC": "（總計）"
      },
      "INCOMING_MESSAGES": {
        "NAME": "收到的訊息",
        "DESC": "（總計）"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "發送的訊息",
        "DESC": "（總計）"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "首次回應時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "首次回應時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_TIME": {
        "NAME": "解決時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "解決時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "最近 7 天"
      },
      {
        "id": 1,
        "name": "最近 30 天"
      },
      {
        "id": 2,
        "name": "最近 3 個月"
      },
      {
        "id": 3,
        "name": "最近 6 個月"
      },
      {
        "id": 4,
        "name": "去年"
      },
      {
        "id": 5,
        "name": "自訂日期範圍"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "套用",
      "PLACEHOLDER": "選擇日期範圍"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "標籤總覽",
    "DESCRIPTION": "透過對話數、回應時間、解決時間及已解決案件等關鍵指標追蹤標籤績效。點擊標籤名稱以取得詳細分析。",
    "LOADING_CHART": "正在載入圖表資料...",
    "NO_ENOUGH_DATA": "我們尚未收到足夠的資料來產生報表，請稍後再試。",
    "DOWNLOAD_LABEL_REPORTS": "下載標籤報表",
    "FILTER_DROPDOWN_LABEL": "選擇標籤",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "搜尋標籤"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "對話",
        "DESC": "（總計）"
      },
      "INCOMING_MESSAGES": {
        "NAME": "收到的訊息",
        "DESC": "（總計）"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "發送的訊息",
        "DESC": "（總計）"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "首次回應時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "首次回應時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_TIME": {
        "NAME": "解決時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "解決時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "最近 7 天"
      },
      {
        "id": 1,
        "name": "最近 30 天"
      },
      {
        "id": 2,
        "name": "最近 3 個月"
      },
      {
        "id": 3,
        "name": "最近 6 個月"
      },
      {
        "id": 4,
        "name": "去年"
      },
      {
        "id": 5,
        "name": "自訂日期範圍"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "套用",
      "PLACEHOLDER": "選擇日期範圍"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "收件匣總覽",
    "DESCRIPTION": "快速檢視收件匣績效，包含對話數、回應時間、解決時間及已解決案件等關鍵指標。點擊收件匣名稱以取得更多詳情。",
    "LOADING_CHART": "正在載入圖表資料...",
    "NO_ENOUGH_DATA": "我們尚未收到足夠的資料來產生報表，請稍後再試。",
    "DOWNLOAD_INBOX_REPORTS": "下載收件匣報表",
    "FILTER_DROPDOWN_LABEL": "選擇收件匣",
    "ALL_INBOXES": "所有收件匣",
    "SEARCH_INBOX": "搜尋收件匣",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "搜尋收件匣"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "對話",
        "DESC": "（總計）"
      },
      "INCOMING_MESSAGES": {
        "NAME": "收到的訊息",
        "DESC": "（總計）"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "發送的訊息",
        "DESC": "（總計）"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "首次回應時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "首次回應時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_TIME": {
        "NAME": "解決時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "解決時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "最近 7 天"
      },
      {
        "id": 1,
        "name": "最近 30 天"
      },
      {
        "id": 2,
        "name": "最近 3 個月"
      },
      {
        "id": 3,
        "name": "最近 6 個月"
      },
      {
        "id": 4,
        "name": "去年"
      },
      {
        "id": 5,
        "name": "自訂日期範圍"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "套用",
      "PLACEHOLDER": "選擇日期範圍"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "團隊總覽",
    "DESCRIPTION": "透過對話數、回應時間、解決時間及已解決案件等關鍵指標，快速掌握團隊績效。點擊團隊名稱以取得更多詳情。",
    "LOADING_CHART": "正在載入圖表資料...",
    "NO_ENOUGH_DATA": "我們尚未收到足夠的資料來產生報表，請稍後再試。",
    "DOWNLOAD_TEAM_REPORTS": "下載團隊報表",
    "FILTER_DROPDOWN_LABEL": "選擇團隊",
    "FILTERS": {
      "ADD_FILTER": "新增篩選條件",
      "CLEAR_ALL": "全部清除",
      "NO_FILTER": "沒有可用的篩選條件",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "搜尋團隊"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "對話",
        "DESC": "（總計）"
      },
      "INCOMING_MESSAGES": {
        "NAME": "收到的訊息",
        "DESC": "（總計）"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "發送的訊息",
        "DESC": "（總計）"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "首次回應時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "首次回應時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_TIME": {
        "NAME": "解決時間",
        "DESC": "（平均）",
        "INFO_TEXT": "用於計算的對話總數：",
        "TOOLTIP_TEXT": "解決時間為 {metricValue}（基於 {conversationCount} 則對話）"
      },
      "RESOLUTION_COUNT": {
        "NAME": "已解決數量",
        "DESC": "（總計）"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "最近 7 天"
      },
      {
        "id": 1,
        "name": "最近 30 天"
      },
      {
        "id": 2,
        "name": "最近 3 個月"
      },
      {
        "id": 3,
        "name": "最近 6 個月"
      },
      {
        "id": 4,
        "name": "去年"
      },
      {
        "id": 5,
        "name": "自訂日期範圍"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "套用",
      "PLACEHOLDER": "選擇日期範圍"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT 報表",
    "NO_RECORDS": "尚無回覆",
    "NO_RECORDS_DESCRIPTION": "當客戶開始提供回饋後，CSAT 問卷回覆將顯示於此。",
    "DOWNLOAD": "下載 CSAT 報表",
    "DOWNLOAD_FAILED": "無法下載 CSAT 報表",
    "FILTERS": {
      "ADD_FILTER": "新增篩選條件",
      "CLEAR_ALL": "全部清除",
      "NO_FILTER": "沒有可用的篩選條件",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "搜尋客服",
        "INBOXES": "搜尋收件匣",
        "TEAMS": "搜尋團隊",
        "RATINGS": "搜尋評分"
      },
      "AGENTS": {
        "LABEL": "客服"
      },
      "INBOXES": {
        "LABEL": "收件匣"
      },
      "TEAMS": {
        "LABEL": "團隊"
      },
      "RATINGS": {
        "LABEL": "評分"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "聯絡人",
        "AGENT_NAME": "客服",
        "RATING": "評分",
        "FEEDBACK_TEXT": "回饋意見",
        "CONVERSATION": "對話",
        "CUSTOMER": "客戶",
        "RESPONSE": "回覆",
        "HANDLED_BY": "處理人員"
      },
      "UNKNOWN_CUSTOMER": "未知客戶"
    },
    "NO_AGENT": "未指派客服",
    "NO_FEEDBACK": "未提供回饋",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "總回覆數",
        "TOOLTIP": "收集到的回覆總數"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "滿意度分數",
        "TOOLTIP": "正面回覆總數 / 回覆總數 * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "回覆率",
        "TOOLTIP": "回覆總數 / 已發送的 CSAT 問卷訊息總數 * 100"
      },
      "RATING_DISTRIBUTION": "評分分布"
    },
    "REVIEW_NOTES": {
      "TITLE": "審閱備註",
      "PLACEHOLDER": "為此評分新增審閱備註...",
      "SAVE": "儲存",
      "CANCEL": "取消",
      "SAVING": "儲存中...",
      "SAVED": "備註已成功儲存",
      "SAVE_ERROR": "無法儲存備註",
      "UPDATED_BY": "由 {name} 於 {time} 更新",
      "UPDATED_BY_LABEL": "更新者",
      "PAYWALL": {
        "TITLE": "升級以新增審閱備註",
        "AVAILABLE_ON": "審閱備註功能僅適用於 Business 和 Enterprise 方案。",
        "UPGRADE_PROMPT": "透過審閱備註為每則 CSAT 回覆新增內部備註。記錄實際情況、更快發現問題模式，並從回饋中做出更好的決策。",
        "UPGRADE_NOW": "立即升級",
        "CANCEL_ANYTIME": "您可以隨時變更或取消方案"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "機器人報表",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "對話數量",
        "TOOLTIP": "機器人處理的對話總數"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "總回覆數",
        "TOOLTIP": "機器人發送的回覆總數"
      },
      "RESOLUTION_RATE": {
        "LABEL": "解決率",
        "TOOLTIP": "機器人解決的對話數 / 機器人處理的對話總數 * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "轉接率",
        "TOOLTIP": "轉接給客服的對話數 / 機器人處理的對話總數 * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "總覽",
    "LIVE": "即時",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "進行中的對話",
      "LOADING_MESSAGE": "正在載入對話指標...",
      "OPEN": "開啟",
      "UNATTENDED": "無人處理",
      "UNASSIGNED": "未指派",
      "PENDING": "待處理"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "對話流量",
      "NO_CONVERSATIONS": "沒有對話",
      "CONVERSATION": "{count} 則對話",
      "CONVERSATIONS": "{count} 則對話",
      "DOWNLOAD_REPORT": "下載報表"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "已解決案件",
      "NO_CONVERSATIONS": "沒有對話",
      "CONVERSATION": "{count} 則對話",
      "CONVERSATIONS": "{count} 則對話",
      "DOWNLOAD_REPORT": "下載報表"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "依客服分類的對話",
      "LOADING_MESSAGE": "正在載入客服指標...",
      "NO_AGENTS": "目前沒有客服的對話紀錄",
      "TABLE_HEADER": {
        "AGENT": "客服",
        "OPEN": "開啟",
        "UNATTENDED": "無人處理",
        "STATUS": "狀態"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "所有團隊",
      "HEADER": "依團隊分類的對話",
      "LOADING_MESSAGE": "正在載入團隊指標...",
      "NO_TEAMS": "目前沒有可用資料",
      "TABLE_HEADER": {
        "TEAM": "團隊",
        "OPEN": "開啟",
        "UNATTENDED": "無人處理",
        "STATUS": "狀態"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "客服狀態",
      "ONLINE": "上線",
      "BUSY": "忙碌中",
      "OFFLINE": "離線"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "星期日",
    "MONDAY": "星期一",
    "TUESDAY": "星期二",
    "WEDNESDAY": "星期三",
    "THURSDAY": "星期四",
    "FRIDAY": "星期五",
    "SATURDAY": "星期六"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA 報表",
    "NO_RECORDS": "目前沒有套用 SLA 的對話。",
    "LOADING": "正在載入 SLA 資料...",
    "DOWNLOAD_SLA_REPORTS": "下載 SLA 報表",
    "DOWNLOAD_FAILED": "無法下載 SLA 報表",
    "DROPDOWN": {
      "ADD_FIlTER": "新增篩選條件",
      "CLEAR_ALL": "全部清除",
      "CLEAR_FILTER": "清除篩選條件",
      "EMPTY_LIST": "查無結果",
      "NO_FILTER": "沒有可用的篩選條件",
      "SEARCH": "搜尋篩選條件",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA 名稱",
        "AGENTS": "客服名稱",
        "INBOXES": "收件匣名稱",
        "LABELS": "標籤名稱",
        "TEAMS": "團隊名稱"
      },
      "SLA": "SLA 政策",
      "INBOXES": "收件匣",
      "AGENTS": "客服",
      "LABELS": "標籤",
      "TEAMS": "團隊"
    },
    "WITH": "包含",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "達成率",
        "TOOLTIP": "已建立的 SLA 中成功完成的百分比"
      },
      "NO_OF_MISSES": {
        "LABEL": "未達成次數",
        "TOOLTIP": "特定期間內的 SLA 未達成總次數"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "對話數量",
        "TOOLTIP": "套用 SLA 的對話總數"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "政策",
        "CONVERSATION": "對話",
        "AGENT": "客服"
      },
      "VIEW_DETAILS": "檢視詳情"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "收件匣",
    "AGENT": "客服",
    "TEAM": "團隊",
    "LABEL": "標籤",
    "AVG_RESOLUTION_TIME": "平均解決時間",
    "AVG_FIRST_RESPONSE_TIME": "平均首次回應時間",
    "AVG_REPLY_TIME": "平均客戶等待時間",
    "RESOLUTION_COUNT": "已解決數量",
    "CONVERSATIONS": "對話數量"
  }
}
